webpackJsonp([10],{

/***/ 261:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(595)
}
var Component = __webpack_require__(96)(
  /* script */
  __webpack_require__(554),
  /* template */
  __webpack_require__(635),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1b6641fe",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 522:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addProblemsMainFromStartMain;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_fetch__ = __webpack_require__(13);


function addProblemsMainFromStartMain(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/addProblemsMainFromStartMain',
    data: data,
    method: 'post'
  });
}

/***/ }),

/***/ 554:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_api_managerPage_js__ = __webpack_require__(522);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      startMain: 0
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['welcome'])),
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    showMsg: function showMsg(msg) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'warning';

      this.$notify({
        title: '出题',
        message: msg,
        type: type
      });
    },
    commit: function commit() {},
    initUser: function initUser() {},
    addProblemMain: function addProblemMain() {
      var _this = this;

      console.log('----------从 ' + this.startMain + ' 开始向后加1');
      var sm = {};
      sm.startMain = this.startMain;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_api_managerPage_js__["a" /* addProblemsMainFromStartMain */])(sm)(this.pInfo).then(function (res) {
        if (res.data) {
          if (res.data.isOk === true) {
            _this.showMsg('加题号成功。', 'info');
          } else {
            _this.showMsg('加题号失败。', 'info');
          }
        } else {
          _this.showMsg('加题号不成功。', 'info');
        }
      }).catch(function (err) {
        _this.showMsg('\u52A0\u9898\u53F7\u5931\u8D252\u3002' + err);
      });
    }
  }
});

/***/ }),

/***/ 568:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(253)(true);
// imports


// module
exports.push([module.i, ".centerdiv[data-v-1b6641fe]{height:auto;text-align:center}.labright[data-v-1b6641fe]{height:50px;line-height:40px}.labright[data-v-1b6641fe],.rowheight[data-v-1b6641fe]{text-align:left;vertical-align:middle}.textleft[data-v-1b6641fe]{text-align:left;height:30px}.lableft[data-v-1b6641fe]{text-align:left}.avatar-uploader .el-upload[data-v-1b6641fe]{border:1px dashed #d9d9d9;border-radius:6px;cursor:pointer;position:relative;overflow:hidden}.avatar-uploader .el-upload[data-v-1b6641fe]:hover{border-color:#20a0ff}.avatar-uploader-icon[data-v-1b6641fe]{font-size:28px;color:#8c939d;width:178px;height:178px;line-height:178px;text-align:center}.avatar[data-v-1b6641fe]{width:178px;height:178px;display:block}", "", {"version":3,"sources":["E:/mywork/math/mathManager/src/pages/managerPage.vue"],"names":[],"mappings":"AACA,4BACE,YAAa,AACb,iBAAmB,CACpB,AACD,2BACE,YAAa,AACb,gBAAkB,CAGnB,AACD,uDAHE,gBAAiB,AACjB,qBAAuB,CAKxB,AACD,2BACE,gBAAiB,AACjB,WAAa,CACd,AACD,0BACE,eAAiB,CAClB,AACD,6CACE,0BAA2B,AAC3B,kBAAmB,AACnB,eAAgB,AAChB,kBAAmB,AACnB,eAAiB,CAClB,AACD,mDACE,oBAAsB,CACvB,AACD,uCACE,eAAgB,AAChB,cAAe,AACf,YAAa,AACb,aAAc,AACd,kBAAmB,AACnB,iBAAmB,CACpB,AACD,yBACE,YAAa,AACb,aAAc,AACd,aAAe,CAChB","file":"managerPage.vue","sourcesContent":["\n.centerdiv[data-v-1b6641fe] {\n  height: auto;\n  text-align: center;\n}\n.labright[data-v-1b6641fe] {\n  height: 50px;\n  line-height: 40px;\n  text-align: left;\n  vertical-align: middle;\n}\n.rowheight[data-v-1b6641fe]{\n  text-align: left;\n  vertical-align: middle;\n}\n.textleft[data-v-1b6641fe] {\n  text-align: left;\n  height: 30px;\n}\n.lableft[data-v-1b6641fe] {\n  text-align: left;\n}\n.avatar-uploader .el-upload[data-v-1b6641fe] {\n  border: 1px dashed #d9d9d9;\n  border-radius: 6px;\n  cursor: pointer;\n  position: relative;\n  overflow: hidden;\n}\n.avatar-uploader .el-upload[data-v-1b6641fe]:hover {\n  border-color: #20a0ff;\n}\n.avatar-uploader-icon[data-v-1b6641fe] {\n  font-size: 28px;\n  color: #8c939d;\n  width: 178px;\n  height: 178px;\n  line-height: 178px;\n  text-align: center;\n}\n.avatar[data-v-1b6641fe] {\n  width: 178px;\n  height: 178px;\n  display: block;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 595:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(568);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(254)("c28ca2ce", content, true);

/***/ }),

/***/ 635:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "centerdiv"
  }, [_c('h2', [_vm._v("辅助功能")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 6
    }
  }, [_vm._v("从多少号开始（含此大题）")]), _vm._v(" "), _c('el-col', {
    staticClass: "lableft",
    attrs: {
      "span": 6
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.startMain),
      callback: function($$v) {
        _vm.startMain = $$v
      },
      expression: "startMain"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "textleft",
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addProblemMain
    }
  }, [_vm._v("增加大题号")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "lableft",
    attrs: {
      "span": 6
    }
  }, [_vm._v("初始化用户到第一题，用户GUID")]), _vm._v(" "), _c('el-col', {
    staticClass: "lableft",
    attrs: {
      "span": 6
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.startMain),
      callback: function($$v) {
        _vm.startMain = $$v
      },
      expression: "startMain"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "lableft",
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.initUser
    }
  }, [_vm._v("初始化")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 9
    }
  }, [_vm._v("参考网址：")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 22
    }
  }, [_vm._v("katex公式网址：https://khan.github.io/KaTeX/docs/supported.html")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 22
    }
  }, [_vm._v("内部链接写法：#/answer?title=知识点&guid=...")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 22
    }
  }, [_vm._v("内部pdf链接写法：#/pdf?title=1000个数学难题&url=...")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 22
    }
  }, [_vm._v("外部链接写法：#/outPage?title=欧拉&url=https://baike.baidu.com/...")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 22
    }
  }, [_vm._v("数学绘图网站：www.geogebra.org")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 22
    }
  }, [_vm._v("数学公式生成透明图：http://www.codecogs.com/latex/eqneditor.php")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 22
    }
  }, [_vm._v("查看关卡地内容地址：localhost:8080/#/level?level=2")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 22
    }
  }, [_vm._v("压缩图片网址：https://tinypng.com/ --png用它；https://squoosh.app/  --jpg用它")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 22
    }
  }, [_vm._v("跳转到用户主页：#/userInfo/d6c0a240bd4211e89076535ee3dd7eaf")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 22
    }
  }, [_vm._v("mathWeb中题目访问方法：mathmarch.com/problem/9a8414e016e311f08fa3abd5fe2eb099")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 22
    }
  }, [_vm._v("mathWeb中知识点访问方法：mathmarch.com/knowledge/96fce2203b4d11ee83fff95b5f929ea9")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 22
    }
  }, [_vm._v("题目中加入动画的方法：@@交互演示@@，然后加上阿里OSS下的链接，如：\nhttps://longmathimg.oss-cn-shanghai.aliyuncs.com/animate/assets/12k_pid_6.js，然后在 animateJSNames中输入JS名12k_pid_6，如果有多个，全输入并用逗号分隔。")])], 1)], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/10.317a3f840cf97363f3eb.js